import React, { useState, useRef, useEffect } from 'react';
import ManageBeneficiary from '../../components/Beneficiary/ManageBeneficiary';
import { useSelector } from 'react-redux';
import SubHeader from '../../components/Subheader/Subheader';
import CreateButton from '../../components/Tools/CreateButton';
import { useLocation } from 'react-router-dom';
import CustomBreadcrumbs from '../../components/Tools/Breadcumbs';
import MainFilter from '../../components/Tools/MainFilter';
import DashboardFilter from '../Dashboard/components/DashboardFilter';

const BeneficiariesMgt = () => {
    const { authData, financialYears } = useSelector((state) => state.authData);
    const fy_list = financialYears.payload.fy_list;
    const fyIdRef = useRef(localStorage.getItem('globalDateId'));
    const [key] = useState('list');
    const [title, setTitle] = useState('');
    const location = useLocation();

    const [filterPayload, setFilterPayload] = useState({
        searchStr: '',
        fromDate: '',
        toDate: '',
        dateColumn: '',
        department_id: '',
        tier: '',
        consolidate: false,
    });

    const [filterApplied, setFilterApplied] = useState({
        searchStr: '',
        fromDate: '',
        toDate: '',
        dateColumn: '',
        department_id: '',
        tier: '',
        consolidate: false,
    });

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleInput = async (e) => {
        const { name, value } = e.target;
        setFilterPayload((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const bootList = async () => {
        setFilterApplied(filterPayload);
        setOpen(false);
    };

    const handleFilterRemove = async (name) => {
        const newPayload = {
            ...filterPayload,
            [name]: '',
        };
        setFilterPayload(newPayload);
        setFilterApplied(newPayload);
    };

    useEffect(() => {
        if (location.pathname.includes('agency') || location.search.includes('agency')) {
            setTitle('Agency');
        } else {
            setTitle('Vendor');
        }
    }, [location]);

    const handlePageTrigger = () => {
        fyIdRef.current = localStorage.getItem('globalDateId');
    };

    return (
        <div className='fund_list'>
            <SubHeader fy_list={fy_list} handlePageTrigger={handlePageTrigger} />
            <div className='scheme p-3'>
                <div className="row" style={{ padding: '10px 16px' }}>
                    <div className="col-md-6">
                        <h4 style={{ color: '#28326f', margin: 0 }}>{title}</h4>
                        <CustomBreadcrumbs linksArray={[]} title={title} />
                    </div>
                    <div className="col-md-6">
                        <div className="d-flex gap-2" style={{ width: 'auto', float: 'right' }} />
                    </div>
                </div>
                <DashboardFilter
                    openFilterModal={setOpen}
                    filterPayload={filterApplied}
                    handleFilterRemove={handleFilterRemove}
                    isTierRemovalRequired={true}
                />
                <ManageBeneficiary
                    listType={key}
                    departmentId={filterApplied.department_id}
                />
                <MainFilter
                    open={open}
                    handleClose={handleClose}
                    handleInput={handleInput}
                    handleOpen={handleOpen}
                    handleFilterClick={bootList}
                    filterPayload={filterPayload}
                    setConsolidate={setFilterPayload}
                    type="Beneficiaries"
                />
            </div>
            {authData.user.user_type === 'l1' && (
                location.pathname.includes('agency') || location.search.includes('agency') ? (
                    <CreateButton title={`Add ${title}`} url={'/add-beneficiary?type=agency'} />
                ) : (
                    <CreateButton title={`Add ${title}`} url={'/add-beneficiary'} />
                )
            )}
        </div>
    );
};

export default BeneficiariesMgt;
